import type {
  InfogreffeOrder,
  InfogreffeOrderType,
} from "@tudigo-monorepo/core-tudigo-api-models";
import type { CollectionRequestParams } from "@tudigo-monorepo/web-tudigo-api-client";

import { ContentType, Request, RequestParams, TudigoResponse } from "../api";

export type GetInfogreffeOrdersFilters = object | undefined; // TODO: add filters

export type GetInfogreffeOrdersQueryParams = CollectionRequestParams<
  undefined,
  GetInfogreffeOrdersFilters
>;

export type CreateInfogreffeOrderBody = {
  type: InfogreffeOrderType;
  siren: string;
};

export const infogreffeEndpoints = (request: Request) => ({
  getInfogreffeOrders: (queryParams?: GetInfogreffeOrdersQueryParams) =>
    request<TudigoResponse<InfogreffeOrder[]>, void>({
      path: "/api/v1/infogreffe-orders",
      method: "GET",
      query: {
        fields: queryParams?.fields,
        ...queryParams?.filters,
        ...queryParams?.pagination,
        ...queryParams?.sorting,
      },
      secure: true,
      type: ContentType.Json,
    }),

  createInfogreffeOrder: (
    body: CreateInfogreffeOrderBody,
    queryParams: GetInfogreffeOrdersQueryParams = {},
    params: RequestParams = {},
  ) =>
    request<TudigoResponse<InfogreffeOrder>, void>({
      path: "/api/v1/infogreffe-orders",
      method: "POST",
      query: {
        fields: queryParams?.fields,
        ...queryParams?.filters,
        ...queryParams?.pagination,
        ...queryParams?.sorting,
      },
      body,
      secure: true,
      type: ContentType.Json,
      ...params,
    }),
});
